<template>
    <div class="o-dashboard">
        <c-table class="o-dashboard__table-accounts c-table--wrap c-table--today"
            :columns="columns"
            :placeholder="'Zoeken op aanvraag, aanvraag, nummer, status...'"
            :endpoint="'/api/requests/today/'"
            :key="'table-in-progress'"></c-table>
    </div>
</template>

<script>
import CTable from '@components/table/Container';
import View from '@mixins/View';

export default {
	components: { CTable },
	mixins: [ View ],

    // Check the 'c-table--today' scss when there will be more data/columns added to this table.
    computed: {
        columns() {
            return [
                { name: 'datum', label: 'Datum dienst', sortable: true, component: 'CColumnDate' },
                { name: 'begintijd', label: 'Begintijd', sortable: true, sort: 'asc', component: 'CColumnTime' },
                { name: 'eindtijd', label: 'Eindtijd', sortable: true, component: 'CColumnTime' },
                { name: 'opdrachtgever_naam', label: 'Aanvrager', sortable: true },
                { name: 'naam_gespreksvoerder', label: 'Gespreksvoerder', sortable: true },
                { name: 'kenmerk', label: 'Kenmerk', sortable: true },
                { name: 'taal', label: 'Taal', sortable: true },
                { name: 'naamtolk', label: 'Naam tolk', sortable: true },
                { name: 'telefoontolk', label: 'Telefoonnummer', sortable: true },
                { name: 'id', label: '', component: 'CColumnButton', props: { route: 'request-detail' }}
            ]
        }
    }
}
</script>
